import React from "react"

import SelectGenericNew from "../../../../gd-ui/select-generic-new/select-generic-new"
import {FieldAutomationActionFormProps} from "../../../render/automation-action-form";
import PropTypes from "prop-types";

const debug = false
// const debug = "DateActionForm"


export default class FieldTags_AutomationActionForm extends React.Component<FieldAutomationActionFormProps,any> {

    static propTypes = {
        config          : PropTypes.object,

        options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    onChangeToValue     = (option:any)  => this.props.onChangeCallback({toValue: option.value})

    render() {
        return (
            <div className="flex-r fl-as">
                <div className="label ui5-txt-not-important-small h-36 fl-ac"/>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {this.props.field.getAutomationOptions()}
                                  value                         = {this.props.config.toValue}
                                  popoverScrollContainerClasses = "max-h-200 max-w-200"
                                  isSearchable                  = {true}
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeToValue}/>
            </div>
        )
    }
}

